import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { Button, Container, Row, Col, Spinner } from 'reactstrap';
import moment from 'moment';
import 'bootstrap/dist/css/bootstrap.min.css';
import api from '../services/api';

const TimePicker = ({ bookingDate, service, event, onTimeSelected }) => {
  const [times, setTimes] = useState([]);
  const [loading, setLoading] = useState(true);

  const formattedDate = useMemo(() => moment(bookingDate).format('YYYY-MM-DD'), [bookingDate]);

  const getAvailableTimes = useCallback(() => {
    setLoading(true);
    api.get(`/available-times/?date=${formattedDate}&service=${service.id}&event=${event}`)
      .then(res => {
        const now = moment();
        const filteredTimes = res.data.filter(time => moment(time["slot"]).isAfter(now.clone()));
        setTimes(filteredTimes);
      })
      .catch(console.error)
      .finally(() => setLoading(false));
  }, [formattedDate, event, service.id]);

  useEffect(() => {
    getAvailableTimes();
  }, [getAvailableTimes]);

  // Group times by timeOfDay
  const groupedTimes = useMemo(() => {
    return times.reduce((groups, time) => {
      const key = time.timeOfDay || 'Other';
      if (!groups[key]) {
        groups[key] = [];
      }
      groups[key].push(time);
      return groups;
    }, {});
  }, [times]);

  return (
    <Container>
      {loading ? (
        <Row className="justify-content-center">
          <Col className="text-center mt-3">
            <Spinner color="primary" />
            <p>Loading available times...</p>
          </Col>
        </Row>
      ) : times.length > 0 ? (
        Object.keys(groupedTimes).map((timeOfDay) => (
          <div key={timeOfDay}>
            <h5 className="mt-4">{timeOfDay}</h5>
            <Row className="justify-content-start">
              {groupedTimes[timeOfDay].map((time, index) => (
                <Col key={index} xs={6} sm={4} md={3} className="mb-2 d-flex justify-content-center">
                  <Button outline color="primary" block onClick={() => onTimeSelected(time['slot'])}>
                    {moment(time['slot']).format('h:mm a')}
                  </Button>
                </Col>
              ))}
            </Row>
          </div>
        ))
      ) : (
        <Row className="justify-content-center">
          <Col className="text-center mt-3">
            <p>No available times found. Use the custom service option to book in the past.</p>
          </Col>
        </Row>
      )}
    </Container>
  );
};

export default TimePicker;
